import { ReactNode } from 'react';
import LinearProgress from '@mui/material/LinearProgress/LinearProgress';

import { HEADER_HEIGHT } from '../shared/constant';
import { useAppSelector } from '../shared/model';

import { selectIsLoading } from './appSlice';

const style = {
  position: 'absolute',
  top: `${HEADER_HEIGHT}px`,
  width: '100%',
  zIndex: 9999,
};

type Props = {
  children: ReactNode;
};

export const PreloaderProvider = ({ children }: Props) => {
  const isLoading = useAppSelector(selectIsLoading);

  return (
    <>
      {isLoading && <LinearProgress sx={style} />}
      {children}
    </>
  );
};
